module.exports = __webpack_public_path__ + "media/images/lb/610-677bf53882b269e86392174737db3a57.svg";